export default "__VITE_ASSET__21aa388f__"